<template>
  <div class="jobView column">
    <Header />
    <Button layout="back" @click="router.back()" class="show-s">
      <i class="fa fa-arrow-left"></i> Voltar
    </Button>
    <div class="content grid-11">
      <Job :id="this.$route.params.id" />
    </div>
  </div>
</template>

<script>
import Job from "@/views/admin/components/Job.vue";
import Button from "@/components/Button.vue";
import router from "@/router";

export default {
  name: "JobView",
  components: {
    Job,
    Button
  },
  data() {
    return {
      router: router
    };
  }
};
</script>


<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.jobView {
  .content {
    padding: 42px 35px;
    @media (max-width: $small) {
      padding: 7px;
    }
  }
}
</style>
